import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";
import { scrollToElement } from '../../lib/userFunctions';
import { Loading } from '../components/Loading';
import { Pagination } from '../components/Pagination';
import { BookDebateForm } from './BookDebateForm';
import { BookDebateListItem } from './BookDebateListItem';
import { BookDebateTopicRequestForm } from './topic/DebateTopicRequestForm';
import useQueryString from 'utils/hooks/useQueryString';
import Api from 'utils/api/Api';
import { useQuery, keepPreviousData } from "@tanstack/react-query";
const queryString = require("query-string");

export const BookDebateList = () => {
    const navigate = useNavigate();
    const { school, isbn } = useParams();
    const auth = useSelector(state => state.auth);
    const queryParams = useQueryString();

    const requestData = useMemo(() => {
        const paramJson = { page: 0, sort: 'id,desc', isbn };
        return { ...paramJson, ...queryParams };
    }, [queryParams, isbn]);

    const { data: bookDebateList, isFetching } = useQuery({
        queryKey: ['book/debate/list', requestData],
        queryFn: () => Api.get(`/api/book/${requestData.isbn}/debate?page=${requestData.page}&sort=${requestData.sort}`),
        placeholderData: keepPreviousData
    });


    const fetchList = (page = 0, option = {}) => {
        scrollToElement('lnb');
        let tempSearchOption = { ...requestData, ...option, page };
        navigate(`/${school}/book/${isbn}/debate?${queryString.stringify(tempSearchOption)}`);
    }


    // 화면
    // if(props.loading) return <Loading />
    return (
        <div className="section bdT0 book_debate">
            <div className="guide_box">
                <div className="inner">
                    <div className="v_align">
                        <ul className="bullet_list">
                            <li>책에 대한 궁금한 점이나 자신의 생각을 친구들과 나누고 토론해요.</li>
                            <li>인상 깊었던 대목이나 이 책에 나오는 멋진 대사도 함께 나누어 보아요.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="inner">
                <BookDebateTopicRequestForm />

                {auth.authenticated && <BookDebateForm mode="create" className="debate_create reply_write" placeholder="생각 / 질문 만들기" />}

                <ul id="sort_custom" className="sort_custom">
                    <li className={requestData.sort === 'id,desc' ? 'on' : ''}><button type="button" className="sort new" onClick={() => { fetchList(0, { sort: 'id,desc' }) }}>최신순</button></li>
                    <li className={requestData.sort === 'id,asc' ? 'on' : ''}><button type="button" className="sort old" onClick={() => { fetchList(0, { sort: 'id,asc' }) }}>과거순</button></li>
                    <li className={requestData.sort === 'gcount,desc' ? 'on' : ''}><button type="button" className="sort count" onClick={() => { fetchList(0, { sort: 'gcount,desc' }) }}>답글순</button></li>
                </ul>
                <div className="reply_area">
                    <div className="reply_list">
                        {bookDebateList?.data?.list.length === 0 && <div className="no_data"><p>등록된 댓글이 없습니다.</p></div>}
                        {bookDebateList?.data?.list.map((debate) => <BookDebateListItem key={debate.id} debate={debate} isRoot={true} />)}
                        <Loading overlay={true} active={isFetching} />
                    </div>
                </div>
                <Pagination page={bookDebateList?.data?.page} totalPage={bookDebateList?.data?.totalPages} gotoPage={fetchList} />
            </div>
        </div>
    );
}//end